import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BasicCheckbox, BaasicButton } from 'core/components';
import { toDate } from 'core/utils';

function ImportValidationModalTemplate({ importValidationModalStore }) {
    const {
        items,
        onChange,
        updateResource,
        onOpenPumps
    } = importValidationModalStore;

    const validationTasks = items.map(item => {
        return(<tr key={item.id}>
            <td className="wrap">
                {item.message ? item.message : item.validation.name}
            </td>
            <td className="type--right">
                <BasicCheckbox id={item.id} checked={item.isDone} onChange={() => onChange(item)} />
            </td>
            <td>
                {item.coreUser && item.coreUser.fullName}
            </td>
            <td>
                {toDate(item.dateCompleted,true)}
            </td>
        </tr>)
    })

    return (
        <section>
            <div className="row">
                <div className="col col-med-11 u-mar--bottom--tny">
                    <h4>Confirmation list</h4>
                </div>
                {items.length > 0 && (items[0].validation.validationType.abrv === "add-pump" || items[0].validation.validationType.abrv === "add-pump-pole") && 
                    <div className="col col-med-1 u-mar--bottom--tny">
                        <a onClick={()=> onOpenPumps()}>
                            <i 
                                className={`u-icon u-icon--med u-icon--pump align--right`}
                                title="Open pump"
                                >
                            </i>
                        </a>
                    </div>}
            </div>    
            <div className="row">
                <div className="col col-lrg-12 u-mar--bottom--tny">                               
                    <table className="table--preview u-mar--bottom--med">
                        <thead>
                            <tr>
                                <th className="type--left">To Confirm</th>
                                <th className="type--left"></th>
                                <th className="type--left">Completed by user</th>
                                <th className="type--left">Completed</th>
                            </tr>
                        </thead>
                        <tbody>{validationTasks}</tbody>
                    </table>
                </div>
            </div>
            
            <BaasicButton
                className="btn btn--base btn--primary u-mar--left--auto"
                label='Update'
                onClick={() => updateResource()}>
            </BaasicButton> 
        </section> 
    );
    
}

ImportValidationModalTemplate.propTypes = {
    importValidationModalStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(ImportValidationModalTemplate);
